import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import closeRed from '../images/closeRed';
import closeGreen from '../images/closeGreen';

const Btn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  text-decoration: none;
  height: 18px;
  width: 18px;
  margin: 0;
  padding: 0;
  line-height: 1;
`;

const Img = styled.img`
  height: 18px;
  width: 18px;
`;

const Button = props => {
  const imgSrc = props.color === 'green' ? closeGreen : closeRed;
  return (
    <Btn type="button" onClick={props.onClick}>
      <Img src={imgSrc} alt="close" />
    </Btn>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.oneOf(['red', 'green']),
};

Button.defaultProps = {
  onClick: () => {},
  color: 'red',
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/CloseButton.jsx